import React, {FC} from 'react';
import moment from 'moment';
import {Box, Chip} from "@mui/material";
import {useTranslation} from "react-i18next";
import {SetStatePropsType} from "@baseTypes/base";
import {getDateStartEndTemplateByKey} from "@ui/datePicker/helpers/helpers";
import {DATE_START_END_TEMPLATE_ITEMS} from "@ui/datePicker/constants";
import {getChipSxDateStartEndTemplate, sxGrid} from "./sx";

interface IProps {
    dateStart: string,
    dateEnd: string,
    format?: string,
    onChangeDateStart: SetStatePropsType<string>,
    onChangeDateEnd: SetStatePropsType<string>,
    disabled?: boolean,
    actionKeys: string[],
}

const DateStartEndTemplateChips: FC<IProps> = ({
                                                   dateStart,
                                                   dateEnd,
                                                   format,
                                                   onChangeDateStart,
                                                   onChangeDateEnd,
                                                   disabled,
                                                   actionKeys,
                                               }) => {
    const {t} = useTranslation()

    const items = DATE_START_END_TEMPLATE_ITEMS.filter((item) => actionKeys.includes(item.value))

    return (
        <Box sx={sxGrid}>
            {items.map((item) => {
                const template = getDateStartEndTemplateByKey(item.value)
                const templateStart = moment(template.dateStart).format(format)
                const templateEnd = moment(template.dateEnd).format(format)
                const active = templateStart === dateStart && templateEnd === dateEnd

                return (
                    <Chip
                        key={item.value}
                        size={'small'}
                        label={t(item.label)}
                        disabled={disabled}
                        onClick={() => {
                            onChangeDateStart(templateStart)
                            onChangeDateEnd(templateEnd)
                        }}
                        sx={getChipSxDateStartEndTemplate(item.value, active)}
                    />
                )
            })}
        </Box>
    );
};

export default DateStartEndTemplateChips;
